"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    const styleData = e.data;
    if (!styleData)
        return;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    window.adobeDataLayer.push({
        component: {
            customClickInfo: null,
        },
    });
    const analyticsEvent = {};
    analyticsEvent.event = 'cmp:customClick';
    analyticsEvent.component = {
        customClickInfo: {
            compTitle: (styleData === null || styleData === void 0 ? void 0 : styleData.compTitle) || 'NA',
            compLinkURL: (styleData === null || styleData === void 0 ? void 0 : styleData.linkUrl) || 'NA',
            eventName: 'VTO style selected',
            eventLabel: styleData === null || styleData === void 0 ? void 0 : styleData.styleName,
            eventCategory: `AIBA:${styleData.type}`, //  primaryCategory: 'AIBA:<first-time/reapplied>'
        },
    };
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
